import loadData from '../../../helpers/data-loader'

export default {
  async loadDataAsyn() {
    return Promise.resolve(this.loadData())
  },

  loadData(): any {
    return loadData("question_editor_data")
  }
}
